import React from "react";
import styled from "styled-components";
import { LuLayoutDashboard } from "react-icons/lu";
import { VscGraph } from "react-icons/vsc";
import { AiFillCar } from "react-icons/ai";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { PiShieldWarningBold } from "react-icons/pi";
import { MdAnalytics, MdBlock } from "react-icons/md";
import { FaBell } from "react-icons/fa";
import { FaRoute } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { COLORS } from "../../../assets/colors";

const AdminSider = ({ handleItem, currentItem }) => {
  const { currentUser } = useSelector((state) => state.auth);
  const menuItems = [
    { id: "dashboard", label: "Dashboard", icon: <LuLayoutDashboard /> },
    { id: "customers", label: "Users", icon: <BsFillPersonVcardFill /> },
    { id: "bookings", label: "Bookings", icon: <AiFillCar /> },
    { id: "requests", label: "Refunds", icon: <VscGraph /> },
    { id: "rides", label: "Rides", icon: <AiFillCar /> },
    { id: "reports", label: "Reports", icon: <PiShieldWarningBold /> },
    { id: "banned", label: "Banned Users", icon: <MdBlock /> },
    { id: "route", label: "Routes", icon: <FaRoute /> },
    { id: "rideWishes", label: "Ride Wishes", icon: <FaBell /> },
    { id: "analytics", label: "Analytics", icon: <MdAnalytics /> },
    ...(currentUser?.email === "support@gosawari.com"
      ? [{ id: "admins", label: "Admins", icon: <PiShieldWarningBold /> }]
      : []),
  ];

  return (
    <SiderWraper>
      {/* <LogoSection>
        <div className="logo-icon">GS</div>
        <div className="logo-text">
          <h3>GoSawari</h3>
          <span>Admin Panel</span>
        </div>
      </LogoSection> */}
      <div className="main">
        <ul>
          {menuItems.map((item) => (
            <li
              key={item.id}
              onClick={() => handleItem(item.id)}
              className={currentItem === item.id ? "active" : ""}
            >
              <span className="icon">{item.icon}</span>
              <span className="label">{item.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </SiderWraper>
  );
};

export default AdminSider;

const SiderWraper = styled.div`
  width: 100%;
  height: 100%;
  background: ${COLORS.adminSidebar};
  color: #ffffff;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.1);

  .main {
    flex: 1;
    padding: 1.5rem 1rem;

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      li {
        display: flex;
        align-items: center;
        padding: 0.75rem 1rem;
        cursor: pointer;
        border-radius: 8px;
        transition: all 0.2s ease-in-out;
        color: rgba(255, 255, 255, 0.7);

        .icon {
          font-size: 1.25rem;
          margin-right: 1rem;
          display: flex;
          align-items: center;
        }

        .label {
          font-size: 0.95rem;
          font-weight: 500;
        }

        &:hover {
          background: ${COLORS.adminSidebarHover};
          color: #ffffff;
          transform: translateX(4px);
        }

        &.active {
          background: ${COLORS.adminAccent};
          color: #ffffff;
          box-shadow: 0 4px 12px rgba(56, 189, 248, 0.3);

          .icon {
            color: #ffffff;
          }
        }
      }
    }
  }
`;

const LogoSection = styled.div`
  padding: 2rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .logo-icon {
    width: 40px;
    height: 40px;
    background: ${COLORS.adminAccent};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 1.2rem;
    color: #ffffff;
    box-shadow: 0 4px 10px rgba(56, 189, 248, 0.4);
  }

  .logo-text {
    h3 {
      margin: 0;
      font-size: 1.2rem;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    span {
      font-size: 0.75rem;
      color: rgba(255, 255, 255, 0.5);
      text-transform: uppercase;
      letter-spacing: 1px;
    }
  }
`;
